<template>
	<div class="ai_container">
		<Header :title="'My 쿠폰'" :onPrev="handlePrev" />
		<div class="mypage_mycoupon_wrapper">
			<Tab :options="[
				{ label: '보유 쿠폰', value: 'reserve' },
				{ label: '쿠폰 받기', value: 'pending' }
			]" :activeKey="tab" :onChange="handleTabChange" />
			<div v-if=" (tab === 'reserve' && !myCouponList.length) || (tab === 'pending' && !pendingCouponList.length) " class="mypage_mycoupn_empty_wrapper">
				{{ tab === "reserve" ? "보유중인 쿠폰이 없어요." : "받을 수 있는 쿠폰이 없어요." }}
			</div>
			<div v-else>
				<div class="mypage_mycoupon_header">
					<p class="body_7">
						쿠폰
						<strong class="heading_8">{{ tab === "reserve" ? myCouponList.length : pendingCouponList.length }}</strong>
						개
					</p>
					<button v-if="tab === 'pending'" class="body_8_M" @click="handleAllCouponDownload">
						<img src="/static/icons/download.svg" />
						모두받기
					</button>
				</div>
				<ul v-if="tab === 'reserve'" class="mypage_mycoupon_list">
					<CoupnCard v-for="item in myCouponList" :key="item.name" v-bind="item" />
				</ul>
				<ul v-else class="mypage_mycoupon_list">
					<PendingCoupnCard
						v-for="item in pendingCouponList"
						:key="item.name"
						v-bind="item"
						:onClickDownload="fnDownCoupon" />
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Header from '@/components/ai/AiHeader.vue'
import Tab from '@/components/ai/AiTab.vue'
import CoupnCard from '@/components/ai/card/CouponCard.vue'
import PendingCoupnCard from '@/components/ai/card/PendingCouponCard.vue'
import LoginSocial from '@/components/ai/AiLoginSocial.vue'
export default {
	name: 'AiMypageCoupon',
	data() {
		return {
			myCouponList: [],
			pendingCouponList: [],
			tab: 'reserve'
		}
	},
	components: {
		AppConfig,
		Header,
		Tab,
		LoginSocial,
		CoupnCard,
		PendingCoupnCard
	},
	methods: {
		handlePrev() {},
		handleTabChange(value) {
			this.tab = value;
		},

		handleAllCouponDownload() {
			var $this = this;
			Vue.httpClient
			.post('/m/ai/coupon/down/all')
			.then((response) => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
				} else {
				}
			})
			.catch((error)=>{
			})
			.finally(()=>{
				$this.fnGetCoupon();
			})
		},
		fnGetCoupon(){
			var $this = this;
			$this.pendingCouponList=[];
			$this.myCouponList=[];

			Vue.httpClient
			.post('/m/ai/coupon')
			.then((response) => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					if ( response.data.result != undefined ) {
						$this.pendingCouponList = response.data.result.pendingCouponList
						$this.myCouponList = response.data.result.myCouponList
					}
				} else {
				}
			})
			.catch((error)=>{
			})
			.finally(()=>{
			})
		},

		fnDownCoupon(couponSeq){
			var $this = this;
			const params={
				couponSeq:couponSeq
			}
			Vue.httpClient
			.post('/m/ai/coupon/down', params)
			.then((response) => {
				// if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
				// } else {
				// 	throw new Error('오류가 발생했습니다.')
				// }
			})
			.catch((error)=>{
				window.alert(error)
				// console.log(error);
			})
			.finally(()=>{
				$this.fnGetCoupon();
			})
		}
	},

	mounted(){
		var $this = this;
		this.$nextTick(()=>{
			$this.fnGetCoupon();
		})
	}
}
</script>


// WEBPACK FOOTER //
// src/views/ai/mypage/AiMypageCoupon.vue